namespace TabAurous.ECommerce {
    export interface ECommOrderPromoRow {
        TransPromoId?: number;
        TransId?: number;
        PromoId?: number;
        ProductTypeId?: number;
        TotalAmount?: number;
        PromoPer?: number;
        PromoAmount?: number;
        ProductTypeName?: string;
        PromoCode?: string;
        PromoName?: string;
    }

    export namespace ECommOrderPromoRow {
        export const idProperty = 'TransPromoId';
        export const localTextPrefix = 'ECommerce.ECommOrderPromo';
        export const deletePermission = 'EComm:ECommOrder:Delete';
        export const insertPermission = 'EComm:ECommOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommOrder:Edit';

        export declare const enum Fields {
            TransPromoId = "TransPromoId",
            TransId = "TransId",
            PromoId = "PromoId",
            ProductTypeId = "ProductTypeId",
            TotalAmount = "TotalAmount",
            PromoPer = "PromoPer",
            PromoAmount = "PromoAmount",
            ProductTypeName = "ProductTypeName",
            PromoCode = "PromoCode",
            PromoName = "PromoName"
        }
    }
}
